import React from 'react';

export const AccessTokenContext = React.createContext<string|undefined>(undefined);
export const AccessTokenDispatchContext = React.createContext<((value: string|undefined) => void)>(()=>{});
